module.exports = __webpack_public_path__ + "static/media/exec.59ceb551.pdf";